"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EmailSuccess = () => {
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: "tick-outline",
    group: "hifiLight",
    size: 1
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    text: _services.locale.localeString('ShareRecommendation.successTitle')
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    justify: "center"
  }, _services.locale.localeString('ShareRecommendation.successMessage')))));
};
var _default = EmailSuccess;
exports.default = _default;